import { render } from "./HowToCleanADrainCarousel.vue?vue&type=template&id=01f6f4a0"
import script from "./HowToCleanADrainCarousel.vue?vue&type=script&lang=js"
export * from "./HowToCleanADrainCarousel.vue?vue&type=script&lang=js"

import "./HowToCleanADrainCarousel.vue?vue&type=style&index=0&id=01f6f4a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__